import ReactStars from "react-rating-stars-component";

import "./style.css";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const EachListSubCategory = ({
  address,
  discount,
  sub_category_name,
  shop_name,
  tel,
  stars_avg,
  select_icon,
}) => {
  const { pathname } = useLocation();
  return (
    <div className="all-list-sub-category  w-100">
      <Link
        to={pathname}
        className="each-list-sub-category  w-100  d-flex  justify-content-between  mb-2 py-2 px-1 rounded border "
      >
        <div className="small-part-list d-flex align-items-center font-site">
          <img
            src={`https://images.daapapp.com/${select_icon}`}
            alt=""
            className="ms-2 icon-each-business"
          />
          <p className="m-0">{shop_name}</p>
        </div>
        <div className="small-part-list d-flex justify-content-center align-items-center font-site">
          {sub_category_name}
        </div>
        <div className="small-part-list addres-businesses d-flex justify-content-center align-items-center font-site">
          {address}
        </div>
        <div className="small-part-list d-flex justify-content-center align-items-center font-site">
          {tel}
        </div>
        <div className="small-part-list d-flex justify-content-center align-items-center font-site">
          <span className="text-danger">{`%${discount}`}</span> پاداش نقدی خرید{" "}
        </div>
        <div className="small-part-list star-businesses d-flex justify-content-center align-items-center">
          <ReactStars
            edit={false}
            value={parseInt(stars_avg)}
            count={5}
            size={20}
            activeColor="#ffd700"
          />
        </div>
      </Link>
    </div>
  );
};

export default EachListSubCategory;
